module.exports = __webpack_public_path__ + "assets/img/returnBtn-ad57b956.png";